export class User {
        username:any;
        email:any;
        password:any;
        uiVersion:any;
        host:any;
        newpassword:any;
        deviceMeta:any;
}